import React from "react";

const NotFound = () => {
  return (
    <div>
      <h1>OH!! Sorry This page dont exist </h1>
    </div>
  );
};

export default NotFound;
